// frontend/shared-ui/src/components/Input.jsx
import React from "react";

export default function Input({
  label,
  error,
  hint,
  required = false,
  id,
  type = "text",
  className = "",
  onChange,
  ...rest
}) {
  const inputId = id || `fh-input-${Math.random().toString(36).slice(2, 9)}`;

  const handleChange = (e) => {
    if (typeof onChange === "function") onChange(e);
  };

  return (
    <div className={`fh-input-group ${className}`}>
      {label && (
        <label
          htmlFor={inputId}
          className={`fh-input-label ${required ? "fh-input-label--required" : ""}`}
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        className={`fh-input ${error ? "fh-input--error" : ""}`}
        onChange={handleChange}
        {...rest}
      />
      {error && <div className="fh-input-error">{error}</div>}
      {hint && !error && <div className="fh-input-hint">{hint}</div>}
    </div>
  );
}
